<template>
  <page-header-wrapper>
    <div slot="extra">
      <router-link v-action:add :to="{ path: '/jobs/form' }">
        <a-button type="primary" icon="plus">发布招聘</a-button>
      </router-link>
    </div>
    <a-card :bordered="false" class="ant-pro-components-tag-select">
      <a-form layout="inline">
        <standard-form-row block>
          <div class="ant-pro-page-header-search">
            <a-input-search
              size="large"
              style="width: 80%; max-width: 522px;"
              v-model="params.where.name"
              placeholder="请输入名称"
              enter-button
              @search="getLists()"
            />
            <a-button type="link" @click="() => (this.search = !this.search)">
              高级筛选
              <a-icon :type="search ? 'up' : 'down'" />
            </a-button>
          </div>
        </standard-form-row>
        <template v-if="search">
          <standard-form-row title="排序" grid>
            <a-row>
              <a-col :lg="20" :md="20" :sm="24" :xs="24">
                <a-form-item :wrapper-col="{ sm: { span: 20 }, xs: { span: 24 } }">
                  <a-radio-group v-model="orderID" @change="handleChangeOrder">
                    <a-radio-button value="id">ID</a-radio-button>
                    <a-radio-button value="order">排序</a-radio-button>
                    <a-radio-button value="created_at">创建时间</a-radio-button>
                    <a-radio-button value="updated_at">修改时间</a-radio-button>
                  </a-radio-group>
                </a-form-item>
              </a-col>
              <a-col :lg="4" :md="4" :sm="24" :xs="24">
                <a-form-item :wrapper-col="{ sm: { span: 24 }, xs: { span: 24 } }">
                  <a-select
                    placeholder="不限"
                    v-model="orderVal"
                    style="width: 120px"
                    @change="handleChangeOrder"
                  >
                    <a-select-option value="asc">升序</a-select-option>
                    <a-select-option value="desc">降序</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
          </standard-form-row>
          <standard-form-row title="创建日期" block>
            <a-form-item :wrapper-col="{ sm: { span: 8 }, xs: { span: 24 } }">
              <a-range-picker
                :ranges="{
                  最近七天: [moment().subtract('days', 6), moment()],
                  今天: [moment(), moment()],
                  本月: [moment(), moment().endOf('month')]
                }"
                :placeholder="['开始日期', '结束日期']"
                @change="values => handleChangeDate(values)"
              />
            </a-form-item>
          </standard-form-row>
        </template>
      </a-form>
    </a-card>
    <a-card title="招聘信息" style="margin-top: 24px;" :bordered="false">
      <div slot="extra" class="change-state">
        <a-radio-group @change="searchChangeState">
          <a-radio-button value="0">全部</a-radio-button>
          <a-radio-button value="1">展示</a-radio-button>
          <a-radio-button value="2">隐藏</a-radio-button>
        </a-radio-group>
      </div>
      <a-list :loading="loading" :data-source="list" itemLayout="vertical" :pagination="pagination">
        <a-list-item :key="item.id" slot="renderItem" slot-scope="item">
          <a-list-item-meta>
            <a slot="title" href="javascript:;">{{ item.name }}</a>
            <template slot="description">
              <div class="list-items">
                <span>
                  学历：
                  <a-tag>{{ item.education }}</a-tag>
                </span>

              </div>
              <div class="list-items">
                <span>
                  地点：
                  <a-tag>{{ item.place }}</a-tag>
                </span>
              </div>
              <div class="list-items">
                <span>
                  所属公司：
                  <a-tag>{{ item.enterprise.name }}</a-tag>
                </span>
              </div>
              <div class="list-items">
                <span>
                  排序：
                  <a-tag color="blue">{{ item.order }}</a-tag>
                </span>
                <span> 发布于：{{ moment(item.created_at).fromNow() }}</span>
                <span> 末次更新：{{ moment(item.updated_at).fromNow() }}</span>
              </div>
            </template>
          </a-list-item-meta>
          <div slot="actions">
            <a-switch
              v-action:state
              :checked="item.state === 1"
              @change="handleChangeState(item.id)"
              checked-children="展示"
              un-checked-children="隐藏"
            />
          </div>
          <div slot="actions">
            <a href="javascript:;" @click="handleDetail(item)">查看</a>
          </div>
          <div slot="actions">
            <router-link v-action:update :to="'/jobs/form/' + item.id">
              <a>编辑</a>
            </router-link>
          </div>
          <div slot="actions">
            <a-popconfirm
              title="确定要删除该招聘信息吗？"
              ok-text="确定"
              cancel-text="取消"
              @confirm="handleOnDelete(item.id)"
              v-action:delete
            >
              <a href="#">删除</a>
            </a-popconfirm>
          </div>
        </a-list-item>
      </a-list>
    </a-card>
    <a-modal title="查看" :width="700" :visible="visible" @ok="hideModal" @cancel="hideModal">
      <a-descriptions v-if="ModalData" layout="vertical" bordered>
        <a-descriptions-item label="职位名称" :span="3">
          {{ ModalData.name }}
        </a-descriptions-item>
        <a-descriptions-item label="所属公司">
          {{ ModalData.enterprise.name }}
        </a-descriptions-item>
        <a-descriptions-item label="工作地点">
          {{ ModalData.place }}
        </a-descriptions-item>
        <a-descriptions-item label="学历">
          {{ ModalData.education }}
        </a-descriptions-item>
        <a-descriptions-item label="工资">
          {{ ModalData.salary }}
        </a-descriptions-item>
        <a-descriptions-item label="年限" :span="2">
          {{ ModalData.year }}
        </a-descriptions-item>
        <a-descriptions-item label="关键字" :span="3">
          <a-tag v-for="(keyword, key) in (ModalData.keywords || '').split(',')" :key="key">{{
            keyword
          }}</a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="技能要求" :span="3">
          <div v-html="ModalData.skill"> </div>
        </a-descriptions-item>
        <a-descriptions-item label="职位介绍" v-cloak :span="3">
          <div v-html="ModalData.desc"> </div>
        </a-descriptions-item>
      </a-descriptions>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import { TagSelect, StandardFormRow } from '@/components'
import { list, card, select } from '@/mixins'
const TagSelectOption = TagSelect.Option
const apiList = {
    getList: '/jobs',
    delete: '/jobs/',
    changeState: '/jobs/'
}

export default {
    name: 'JobList',
    mixins: [list, card, select],
    components: {
        TagSelect,
        TagSelectOption,
        StandardFormRow
    },
    data () {
        return {
            apiList,
            ModalData: null,
            visible: false
        }
    },
    mounted () {
        this.getLists() // 获取广告位列表
    },
    methods: {
        /**
         * 查看更多
         * data
         * @jdy
         */
        handleDetail (data) {
            this.ModalData = data
            this.visible = true
        },
        /**
         * 隐藏弹出层
         * @jdy
         */
        hideModal () {
            this.visible = false
            this.ModalData = null
        }
    }
}
</script>
